import { Card, Col, Row } from 'antd'
import { useState } from 'react'

import History from './History'
import Map from './Map'
import Summary from './Summary'

import { POLL_INTERVAL } from '~/client'
import HeadTitle from '~/components/HeadTitle'
import Invoice from '~/components/Invoice'
import ModuleSummary from '~/components/Module/Summary'
import { LoadingComponent } from '~/components/Query/utils'
import { PermissionOnly } from '~/components/Session'
import UserSummary from '~/components/User/Summary'
import { useJourneyQuery } from '~/gql/generated/graphql'
import { IDProps } from './Set'
import JourneySetSummary from './Set/Summary'

export const Journey = ({ id }: IDProps) => {
  const [pollInterval, setPollInterval] = useState<number>(POLL_INTERVAL)
  const { data, loading } = useJourneyQuery({
    variables: { id },
    pollInterval,
  })
  const journey = data?.journey
  const isComplete = data?.journey?.is_complete ?? false
  const journeySetId = data?.journey?.journey_set?.id

  if (isComplete && pollInterval !== 0) {
    setPollInterval(0)
  }

  if (loading || !data) return <LoadingComponent />
  if (!journey) {
    return null
  }
  const moduleId = journey.module?.id
  const userId = journey.user?.id
  const invoiceId = journey.invoice?.id

  return (
    <>
      <HeadTitle pageTitle={`Journey ${journey.id}`} />
      <Row gutter={[16, 16]} className="fill-height">
        <Col lg={10} xs={24} className="flex-col">
          <Summary id={journey.id} />
          <History id={journey.id} />
          {journeySetId && <JourneySetSummary id={journeySetId} withLink />}
        </Col>
        <Col lg={14} xs={24} style={{ minHeight: 500 }}>
          <Card
            id="journey-map-card"
            bodyStyle={{ padding: 0 }}
            style={{ containerType: 'size' }}
          >
            <Map
              journey_id={journey.id}
              schemeId={journey.scheme?.id as string}
              activeJourneyId={journey.id}
            />
          </Card>
        </Col>
        <Col lg={12} xs={24}>
          {moduleId && <ModuleSummary id={moduleId} />}
        </Col>
        <PermissionOnly permission="user.view">
          {userId && (
            <Col lg={12} xs={24}>
              <Card id="journey-user-card">
                <UserSummary id={userId} />
              </Card>
            </Col>
          )}
        </PermissionOnly>
        {invoiceId && (
          <Col lg={24} xs={24}>
            <Invoice id={invoiceId} />
          </Col>
        )}
      </Row>
    </>
  )
}

export default Journey
